'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sharedStyles = {
  "RangeSlider": "Polaris-RangeSlider",
  "Track--dashed-after": "Polaris-RangeSlider--trackDashedAfter",
  "Track--dashed": "Polaris-RangeSlider--trackDashed"
};

exports.default = sharedStyles;
